/** Background Tasks result panel for the emit-events runs (both grids, dry run or real). */
import { Alert, LinearProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import * as bgtasksApi from '@/api/bgtasks';
import { ConsoleApiError } from '@/api/client';
import type { EmitEventTaskResult } from '@/api/emitEvents';

import { EmitEventsReport } from './EmitEventsReport';

export function EmitEventsResultPanel({ taskId }: { taskId: string }) {
  const q = useQuery({
    queryKey: ['emit-events-result', taskId],
    queryFn: () => bgtasksApi.result(taskId),
    retry: (failureCount, error) =>
      failureCount < 10 && error instanceof ConsoleApiError && error.status === 404,
    retryDelay: 1200,
    staleTime: Infinity,
  });
  if (q.isLoading) return <LinearProgress />;
  if (q.isError || !q.data) return <Alert severity="warning">The run’s report is not available.</Alert>;
  return <EmitEventsReport result={q.data.result as unknown as EmitEventTaskResult} taskId={taskId} />;
}
